//deps
import { SuperButton as Button } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import styled from "styled-components";

export const DeliveryRendererCartGroupContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.medium} ${theme.spacing.medium} 0`,
    position: "relative",
}));

export const ToastActionButtonWrapper = styled.div(() => ({
    marginLeft: "auto",
}));

export const ToastActionButton = styled(Button)(({ theme }) => ({
    padding: `${theme.spacing.xSmall} ${theme.spacing.small}`,
    border: `1px solid ${theme.colors[theme.colorMode].border_Inverse_Secondary}`,
    borderRadius: theme.spacing.large,
    background: theme.colors[theme.colorMode].border_Inverse_Tertiary,
}));
